export default {
  consultantManager: {
    portrait: {
      getPortrait: 'api/consultantPortrait/getPortrait',
      getPortraitList: 'api/consultantPortrait/getPortraitList',
      exportPortraitList: 'api/consultantPortrait/exportPortraitList',
    },
    consultantInfo: {
      saveOrUpdate: 'api/consultantInfo/saveOrUpdate'
    }
  }
}